import { render } from "./SocialIncentiveButtons.vue?vue&type=template&id=225a1ee1&scoped=true&ts=true"
import script from "./SocialIncentiveButtons.ts?vue&type=script&lang=ts&external"
export * from "./SocialIncentiveButtons.ts?vue&type=script&lang=ts&external"

import "./SocialIncentiveButtons.scss?vue&type=style&index=0&id=225a1ee1&lang=scss&scoped=true&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-225a1ee1"]])

export default __exports__